import { ProductSchema, ProductsSchema } from './product.contract'
import type { Product } from './product.contract'

export const productKeys = {
  adminAll: ['products', 'admin'] as const,
  adminLists: () => [...productKeys.adminAll, 'list'] as const,
  adminList: (producerId: string) => [...productKeys.adminLists(), producerId] as const,
  adminDetails: () => [...productKeys.adminAll, 'detail'] as const,
  adminDetail: (productId: string) => [...productKeys.adminDetails(), productId] as const,
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === 'object'
}

export function parseProductResponse(data: unknown): Product {
  return ProductSchema.parse(isRecord(data) && 'product' in data ? data.product : data)
}

export function parseProductsResponse(data: unknown): Product[] {
  return ProductsSchema.parse(isRecord(data) && Array.isArray(data.items) ? data.items : data)
}
